import { post } from 'tools/request'

export function track(data) {
	setTimeout(() => {
		data.question = window.structuredQuery.get('textQuery')
		post('/portal/track', { data })
	}, 200)
}
export function startHotjar() {
	setTimeout(() => {
		(function(h,o,t,j,a,r){
			h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
			h._hjSettings={hjid:2414460,hjsv:6};
			import('../../integrations/hotJar').then(() => console.log('loaded'))
			/*a=o.getElementsByTagName('head')[0];
			r=o.createElement('script');r.async=1;
			r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
			a.appendChild(r);*/
		})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
	}, 4000)
}
